/* eslint-disable */
const alert = {
  visible: false,
  title: "",
  messageError: "",
};

const state = {
  alert: alert,
};

const getters = {
  getShowAlertError: (state) => {
    return state.alert.visible;
  },
  getTitleAlertError: (state) => {
    return state.alert.title;
  },
  getMessageAlertError: (state) => {
    return state.alert.messageError;
  },
};

const mutations = {
  setShowAlertError: (state, payload) => {
    state.alert.visible = payload.value;
  },
  setTitleAlertError: (state, payload) => {
    state.alert.title = payload.value;
  },
  setMessageAlertError: (state, payload) => {
    state.alert.messageError = payload.value;
  },
  resetAlert: (state, payload) => {
    state.alert = payload.alert;
  },
};

const actions = {
  RESETALERT: ({ commit }) => {
    commit("resetAlert", { alert: alert });
  },
  showAlertError: ({ commit }, payload) => {
    commit("setShowAlertError", { value: true });
    commit("setTitleAlertError", { value: payload.title });
    commit("setMessageAlertError", { value: payload.message });
    setTimeout(() => {
      commit("setShowAlertError", {
        value: false,
      });
    }, 5000);
  },
  hideAlertError: ({ commit }) => {
    commit("setShowAlertError", {
      value: false,
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
